module.exports = __webpack_public_path__ + "img/115053.72e9377d.png";